import type { RegistrationStatus, RegistrationStatusRequest } from "@/modules/events/types/eventDetailsApi"
import type { QueryObserverResult, RefetchOptions } from "@tanstack/react-query"

import { useQuery } from "@tanstack/react-query"

import { getRegistrationStatus } from "@/modules/events/api/getRegistrationStatus"
import { REGISTRATION_STATUS_QUERY_KEY } from "@/modules/events/constants/api"

type RegistrationStatusFetch = {
  registrationStatus?: RegistrationStatus
  isLoadingRequestStatus: boolean
  isSuccessRequestStatus: boolean
  isErrorRequestStatus: boolean
  refetch: (options?: RefetchOptions | undefined) => Promise<QueryObserverResult<RegistrationStatus, Error>>
}

export const useRegistrationStatus = (params: RegistrationStatusRequest): RegistrationStatusFetch => {
  const {
    data: registrationStatus,
    isPending: isLoadingRequestStatus,
    isSuccess: isSuccessRequestStatus,
    isError: isErrorRequestStatus,
    refetch,
  } = useQuery<RegistrationStatus, Error>({
    enabled: !!params?.eventId,
    gcTime: 0,
    queryFn: () => getRegistrationStatus(params),
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [REGISTRATION_STATUS_QUERY_KEY, params.eventId, params.locale],
    staleTime: 0,
  })

  return {
    isErrorRequestStatus,
    isLoadingRequestStatus,
    isSuccessRequestStatus,
    refetch,
    registrationStatus,
  }
}
